<template>
    <a-layout style="height:100%;display: none;">
        <a-layout-content style="height:100%;padding:0px">
            <slot name="lt-singnalr-receiver"></slot>
        </a-layout-content>
    </a-layout>
</template>

<script setup lang="ts">
import * as signalR from '@microsoft/signalr';
import { isNullAndUnDef } from "@/utils/is"
import { onBeforeMount, ref, watch, onMounted, onUnmounted } from 'vue'

const props = defineProps({
    signalrUrl: {
        type: String,
        default: "http://192.168.1.216:8081/notify",
    },
    signalrHub: {
        type: String,
        default: "notify",
    },
    queryMethods: {
        type: String,
        default: "Subcribe",
    },
    queryGroup: {},
    queryGroupArray: {
        type: Array,
        default() {
            return [];
        },
    },
})

let connection = new signalR.HubConnectionBuilder() //服务器地址
    .withUrl(props.signalrUrl, {})
    .configureLogging(signalR.LogLevel.Information)
    .build();

const emits = defineEmits(["signalData"])
const hadleTimeOut = ref(0)
const ifDisByClient = ref(false)

watch(() => props.queryGroup, () => {
    if (connection.state == "Connected") {
        connection.send(props.queryMethods, props.queryGroup);
    }
})

watch(props.queryGroupArray, (value) => {
    if (value.length < 1) {
        return;
    }
    if (connection.state == "Connected") {
        for (var i in props.queryGroupArray) {
            connection.send(props.queryMethods, props.queryGroupArray[i]);
        }
    }
})

const start = async function () {
    if (hadleTimeOut.value != null) {
        clearTimeout(hadleTimeOut.value);
        hadleTimeOut.value = 0;
    }
    if (isNullAndUnDef(connection)) {
        return;
    }
    if (connection) {
        await connection
            .start()
            .then(() => {
                ifDisByClient.value = false;
                console.log("连接");
                if (hadleTimeOut.value != 0) {
                    clearTimeout(hadleTimeOut.value);
                    hadleTimeOut.value = 0;
                }
                if (props.queryGroupArray.length > 0) {
                    for (const i in props.queryGroupArray) {
                        const temp = props.queryGroupArray[i];
                        connection.send(props.queryMethods, props.queryGroupArray[i]);
                    }
                } else {
                    connection.send(props.queryMethods, props.queryGroup);
                }
            })
            .catch(function (err) {
                //@ts-ignore
                hadleTimeOut.value = setTimeout(() => start(), 5000);
                // return console.error(err.toString());
            });
    } else {
        //@ts-ignore
        hadleTimeOut.value = setTimeout(() => start(), 5000);
    }

}
const disConnect = async function () {
    ifDisByClient.value = true; // 由客户端主动断开，onclose 中不再重连
    if (hadleTimeOut.value != null && hadleTimeOut.value !== 0) {
        clearTimeout(hadleTimeOut.value);
        hadleTimeOut.value = 0;
    }
    if (isNullAndUnDef(connection)) {
        return;
    }
    const { Disconnected, Disconnecting } = signalR.HubConnectionState;
    const state = connection.state;
    if (state === Disconnected || state === Disconnecting) {
        return;
    }
    try {
        connection.value.send("UnSubcribe", queryGroupData.ScruSubcribeId);
        await connection.stop();
        console.log("手动断开连接");
    } catch (err) {
        console.warn("手动断开连接失败", err);
    }
}

const handler = (id, serveName, data) => {
    // store.commit("receiveData/setMonitorData",{id, serveName,data})
    emits("signalData", { id, serveName, data });
};


onBeforeMount(() => {
    // connection.on("SendResult", function (id, serveName, data) {
    //     emits("signalData", id, serveName, data);
    // });
    connection.on("SendResult", handler);
})

defineExpose({
    disConnect, start
})

onMounted(() => {
    start();
    connection.onclose(async () => {
        if (ifDisByClient.value == false) {
            console.log("重连");
            await start();
        }
    });
})

onUnmounted(() => {
    connection.off("SendResult", handler);
    connection.stop();
    /* eslint-disable */
    //@ts-ignore
    connection = null; //内存回收
    hadleTimeOut.value = 0;
})


</script>